import React, { useEffect, useState } from 'react';
import { XIcon } from 'lucide-react';
const STORAGE_KEY = 'peak-used-machines-popup-seen';
export function UsedMachinePopup() {
  const [isOpen, setIsOpen] = useState(false);
  useEffect(() => {
    if (!window.location.pathname.includes('used-machines')) {
      return;
    }
    try {
      const seen = window.localStorage.getItem(STORAGE_KEY);
      if (!seen) {
        setIsOpen(true);
      }
    } catch {
      // localStorage unavailable (e.g. SSR / privacy mode) — show popup as fallback
      setIsOpen(true);
    }
  }, []);
  const close = () => {
    setIsOpen(false);
    try {
      window.localStorage.setItem(STORAGE_KEY, 'true');
    } catch {
      // ignore
    }
  };
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-[100] flex items-center justify-center p-4" data-id="element-4093">
      <div className="absolute inset-0 bg-black/60" onClick={close} data-id="element-4094" />
      <div className="relative bg-[#002d4d] rounded-xl shadow-2xl max-w-lg w-full overflow-hidden" data-id="element-4095">
        <button onClick={close} className="absolute top-3 right-3 text-white/70 hover:text-white transition-colors z-10" aria-label="Close popup" data-id="element-4096">
          <XIcon className="w-6 h-6" data-id="element-4097" />
        </button>
        <div className="p-8 text-center" data-id="element-4098">
          <img src="https://cdn.magicpatterns.com/uploads/5H82rnwCrH9dHxQ46pA82h/Peak_Machine_Sales_Home.png" alt="Peak Machine Sales Logo" className="block h-16 w-auto mx-auto mb-6" data-id="element-4099" />
          <h2 className="text-white text-2xl font-bold mb-2" data-id="element-4100">
            Used AgieCharmilles EDM Specialists
          </h2>
          <div className="w-20 h-1 bg-orange mx-auto my-4 rounded-full" data-id="element-4101" />
          <p className="text-gray-300 text-base mb-6 leading-relaxed" data-id="element-4102">
            Peak Machine Sales specializes in quality used AgieCharmilles EDM
            machines. Browse our current inventory of wire EDM, sinker EDM, and
            hole drilling EDM machines below.
          </p>
          <button type="button" onClick={close} className="inline-block bg-orange hover:bg-orange/90 text-white font-bold py-3 px-8 rounded-lg transition-colors text-lg" data-id="element-4103">
            Browse inventory
          </button>
        </div>
        <div className="h-1.5 bg-orange" data-id="element-4104" />
      </div>
    </div>;
}